
<template>
  <div class="main-page-container">
    <AlertFoundActiveSession v-if="currentEntity.package == 'Cloud'" />
    <PageHeader
      :title="$t('sideNavbarMenu.sites.text')"
      :hasHeaderButton="true"
      class="d-flex align-items-center vp-width-270"
    >
      <template #headerButton>
        <AddSiteAreaKioskDropdown
          :disableIfStandAlone="getPackageType == 'Standalone'"
          @siteCreated="fetchDataSource"
          @siteUpdated="fetchDataSource"
        />
      </template>
    </PageHeader>

    <b-alert
      v-if="getPackageType == 'Standalone'"
      show
      dismissible
      variant="warning"
    >
      <i class="mdi mdi-alert-outline mr-2"></i><span v-html="$t('sitesAndDevices.standaloneNote')"/>
    </b-alert>
    <section class="sites-white-bg-sec">
      <DxTreeList
        id="sitesAndAreasTreelist"
        :class="{
          sitesGridHeightWithAlert:
            currentEntity.package == 'Cloud' && getActiveSessionsCount,
          sitesGridHeight:
            currentEntity.package != 'Cloud' || !getActiveSessionsCount,
        }"
        :ref="sitesAndAreasRefName"
        :data-source="dataSource"
        :show-borders="false"
        :show-column-lines="true"
        :show-row-lines="true"
        :column-auto-width="true"
        :word-wrap-enabled="true"
        :allowColumnResizing="true"
        :rowAlternationEnabled="false"
        :repaint-changes-only="true"
        :two-way-binding-enabled="true"
        :expanded-row-keys="expandedRowKeys"
        :allow-column-reordering="true"
        key-expr="id"
        parent-id-expr="mod_Parent_ID"
        @context-menu-preparing="onItemContextMenu"
        @content-ready="contentReady($event)"
        @editor-preparing="onEditorPreparing($event)"
        @data-error-occurred="onDataErrorOccurred($event)"
        :rtl-enabled="rtlEnabled"
        :no-data-text="gridEmptyMessage"
      >
        <DxStateStoring
          :enabled="true"
          type="custom"
          :customSave="customSave"
          :customLoad="customLoad"
        />
        <DxHeaderFilter :visible="true" />
        <!-- <DxSelection mode="multiple" /> -->
        <DxColumnChooser
          :enabled="true"
          mode="select"
          :title="$t('common.grid.columnChooser')"
        />
        <DxFilterRow :visible="true" />
        <DxLoadPanel :enabled="true"> </DxLoadPanel>

        <!-- start::Toolbar -->
        <DxToolbar>
          <DxItem location="before" template="columnButtonTemplate" />
          <DxItem template="exportButtonTemplate" location="before" />
          <DxItem template="expandAll" location="before" />
          <DxItem template="collapseAll" location="before" />
          <DxItem template="clearAllTemplate" location="before" />
        </DxToolbar>
        <!-- end::Toolbar -->

        <!-- start::Pager -->
        <!-- <DxPaging :enabled="true" :page-size="10" /> -->
        <DxPager
          :visible="false"
          displayMode="full"
          :show-page-size-selector="false"
          :allowed-page-sizes="['all']"
          :show-info="true"
          :show-navigation-buttons="true"
          :infoText="rtlEnabled ?  'صفحة {0} من {1} ({2} إجمالي العناصر)' : ''"
        />
        <!-- end::Pager -->

        <!-- start::scrolling -->
        <DxScrolling mode="standard" :scroll-by-content="rtlEnabled" :use-native="!rtlEnabled" />
        <!-- end::scrolling -->

        <!-- start::Column Button Template -->
        <template #columnButtonTemplate>
          <button class="custom-columns" @click="treelist.showColumnChooser()">
            <span class="custom-text">{{ $t("common.grid.columns") }} </span>

            <span class="custom-icon">
              <i class="dx-icon dx-icon-spindown dx-icon-right"></i>
            </span>
          </button>
        </template>
        <!-- end::Column Button Template -->

        <!-- start::Export Button -->
        <template #exportButtonTemplate class="export-dropdown">
          <DxDropDownButton
            class="export-dropdown"
            :items="buttonData"
            @item-click="serverSideExport"
            :text="$t('common.grid.export')"
          />
        </template>
        <!-- end::Export Button -->

        <!-- start::Expand All Button Template -->
        <template #expandAll>
          <button
            class="toolbar-action-button expand-all"
            @click="expandAll"
            :disabled="disableExpandAll"
          >
            <span class="toolbar-action-text">{{
              $t("sitesAndDevices.expandAll")
            }}</span>
          </button>
        </template>
        <!-- end::Expand All Button Template -->

        <!-- start::Collapse All Button Template -->
        <template #collapseAll>
          <button
            class="toolbar-action-button"
            @click="collapseAll"
            :disabled="disableCollapseAll || disableOnAllSitesCollapse"
          >
            <span class="toolbar-action-text">{{
              $t("sitesAndDevices.collapseAll")
            }}</span>
          </button>
        </template>
        <!-- end::Collapse All Button Template -->

        <!-- start::Clear All Button Template -->
        <template #clearAllTemplate>
          <div v-if="showClearAll" class="clear-cols d-flex align-items-center">
            <div class="toolbar-custom-line"></div>
            <Button
              :text="$t('common.grid.clearFilters')"
              @click="clearFilter"
              styling-mode="outlined"
              type="danger"
              class="clear-CustomColums"
            />
          </div>
        </template>
        <!-- end::Clear All Button Template -->

        <!-- start:: name -->
        <DxColumn
          data-field="name"
          :caption="$t('common.name')"
          :allow-header-filtering="true"
          :min-width="350"
          :allow-filtering="true"
          :allow-reordering="false"
          :filter-operations="allowedOperations"
          cell-template="name-cell"
        />
        <template #name-cell="{ data }">
          <div style="overflow-wrap: anywhere">
            <template v-if="data.data.dataType == 'kiosk'">
              <svg
                width="12"
                height="19"
                viewBox="0 0 12 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="margin-inline-end: 5px"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.04347 0.83824C1.04347 0.375293 1.39387 0 1.82608 0H10.1739C10.6061 0 10.9565 0.375293 10.9565 0.83824V16.7647H11.4783C11.7664 16.7647 12 17.0149 12 17.3235V18.4412C12 18.7498 11.7664 19 11.4783 19H0.521733C0.2336 19 0 18.7498 0 18.4412V17.3235C0 17.0149 0.2336 16.7647 0.521733 16.7647H1.04347V0.83824ZM2.08696 2.23531C2.08696 1.92666 2.32056 1.67648 2.60869 1.67648H9.39131C9.67944 1.67648 9.91304 1.92666 9.91304 2.23531V13.4118C9.91304 13.7204 9.67944 13.9706 9.39131 13.9706H2.60869C2.32056 13.9706 2.08696 13.7204 2.08696 13.4118V2.23531ZM3.39131 10.6177C3.10315 10.6177 2.86957 10.8678 2.86957 11.1765V12.2941C2.86957 12.6028 3.10315 12.8529 3.39131 12.8529H8.60869C8.89685 12.8529 9.13043 12.6028 9.13043 12.2941V11.1765C9.13043 10.8678 8.89685 10.6177 8.60869 10.6177H3.39131ZM2.86957 3.35293C2.86957 3.04431 3.10315 2.79411 3.39131 2.79411H8.60869C8.89685 2.79411 9.13043 3.04431 9.13043 3.35293V8.5C9.13043 8.80862 8.89685 9.05883 8.60869 9.05883H3.39131C3.10315 9.05883 2.86957 8.80862 2.86957 8.5V3.35293Z"
                  fill="#103F5E"
                />
              </svg>
            </template>
            {{ data.data.name }}
          </div>
        </template>
        <!-- end:: name -->

        <!-- start:: description -->
        <DxColumn
          :width="250"
          data-field="description"
          :visible="false"
          :caption="$t('common.description')"
          :allow-header-filtering="false"
          :allow-filtering="true"
          :filter-operations="allowedOperations"
          :calculate-cell-value="displayDescription"
          cell-template="description-cell"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <template #description-cell="{ data }">
          <div>
            <div
              v-if="data.value"
              style="
                white-space: normal;
                overflow-wrap: break-word;
                height: 90;
                width: 90;
              "
            >
              <template v-if="!readMore[data.data.id]">
                {{ data.value.substring(0, 37) }}
              </template>

              <template v-if="readMore[data.data.id]">
                {{ data.value }}
              </template>

              <a
                class="read_more"
                v-if="!readMore[data.data.id] && data.value.length >= 37"
                @click="showMore(data.data.id)"
                >{{ $t("common.readMore") }}</a
              >
              <a
                class="read_more"
                v-if="readMore[data.data.id]"
                @click="showLess(data.data.id)"
                >{{ $t("common.readLess") }}</a
              >
            </div>

            <template v-else> - </template>
          </div>
        </template>
        <!-- end:: description -->

        <template #qrCodeTemplate="{ data }">
          <div
            v-if="data.value"
            class="download-pdf"
            @click="
              downloadLoading = true;
              downloadPDF(
                data.data.id,
                data.value,
                data.data.name,
                data.data.journey
              );
            "
            :style="{ pointerEvents: downloadLoading ? 'none' : 'visible' }"
          >
            <div
              v-if="downloadLoading && data.data.id == rowId"
              class="spinner-border"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <span :style="{ color: downloadLoading ? '#A8CCF7' : '#2680eb' }">{{
              downloadLoading && data.data.id == rowId
                ? $t("common.downloading")
                : $t("common.download")
            }}</span>
          </div>
          <div v-else>-</div>
        </template>
        <!-- end:: AreaQrCode -->

        <!-- start::EXE File -->
        <template #exeFileTemplate="{ data }">
          <div
            v-if="
              data.data.loginMode &&
              data.data.loginMode != 'remote_signIn_signOut'
            "
            class="download-pdf"
            @click="generateAndDownloadAreaExeFile(data.data)"
            :style="{ pointerEvents: downloadLoading ? 'none' : 'visible' }"
          >
            <div
              v-if="downloadLoading && data.data.id == exefileRowId"
              class="spinner-border"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <span :style="{ color: downloadLoading ? '#A8CCF7' : '#2680eb' }">{{
              downloadLoading && data.data.id == exefileRowId
                ? $t("common.downloading")
                : $t("common.download")
            }}</span>
          </div>
          <div v-else>-</div>
        </template>
        <!-- end:: EXE File -->

        <!-- start::Login Mode -->
        <DxColumn
          :min-width="150"
          alignment="left"
          data-field="loginMode"
          :caption="$t('common.loginMode')"
          :filter-operations="allowedOperations"
          :customize-text="loginModeDisplay"
          :allow-header-filtering="true"
          :allow-filtering="false"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
          <!-- start::Kiosk Login Mode -->
          <DxColumn
          :min-width="150"
          alignment="left"
          data-field="kiosk_sign_in_out_mode"
          :caption="$t('sitesAndDevices.kioskActions.kioskSignInOutMode')"
          :filter-operations="allowedOperations"
          :allow-header-filtering="true"
          :allow-filtering="false"
          :visible="false"
          :customize-text="defaultDataDisplay"
        >
        </DxColumn>
        <!-- end::Login Mode -->

        <!-- start::Auto Sign out Mode -->
        <DxColumn
          :min-width="200"
          alignment="left"
          data-field="settings[2].label"
          :caption="$t('common.autoSignOut')"
          :filter-operations="allowedOperations"
          :calculate-cell-value="autoSignOutModeDisplay"
          :allow-header-filtering="true"
          :allow-filtering="false"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <!-- end::Auto Sign out Mode -->

        <!-- start::Pre-registeration URL -->
        <DxColumn
          :min-width="210"
          alignment="left"
          data-field="pre_registration_url"
          :caption="$t('common.preRegistrationURL')"
          :filter-operations="allowedOperations"
          cell-template="pregUrlTemplate"
          :calculate-cell-value="preRegUrl"
          :allow-header-filtering="false"
          :allow-filtering="true"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <template #pregUrlTemplate="{ data }">
          <a
            class="area-register-url"
            target="_blank"
            :href="`${data.value}`"
            v-if="data.value"
          >
            {{ data.value }}
          </a>
          <span v-else>-</span>
        </template>
        <!-- end::Pre-registeration URHL -->

        <!-- start::Contact Email -->
        <DxColumn
          :min-width="210"
          :visible="false"
          alignment="left"
          data-field="reception_email"
          :caption="$t('common.email')"
          :calculate-cell-value="emailCell"
          :filter-operations="allowedOperations"
          :allow-header-filtering="false"
          :allow-filtering="true"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <!-- end::Contact Email -->

        <!-- start::Time Zone -->
        <DxColumn
          :visible="false"
          :min-width="150"
          alignment="left"
          data-field="timezone"
          :caption="$t('common.timezone')"
          :allow-filtering="false"
          :allowHeaderFiltering="true"
          :customize-text="defaultDataDisplay"
        >
        </DxColumn>
        <!-- end::Time Zone -->

        <!-- start::Journey Name -->
        <DxColumn
          :min-width="200"
          alignment="left"
          data-field="journey.name"
          :caption="$t('sitesAndDevices.journeyName')"
          :allowFiltering="false"
          :allowHeaderFiltering="true"
          :customize-text="defaultDataDisplay"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <!-- end::Journey Name -->

        <!-- start::Android Serial -->
        <DxColumn
          :visible="false"
          :min-width="200"
          alignment="left"
          data-field="android_serial"
          :caption="$t('sitesAndDevices.androidSerial')"
          :allowFiltering="false"
          :allowHeaderFiltering="true"
          :customize-text="defaultDataDisplay"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <!-- end::Android Serial -->

        <!-- start::LamasaTech Serial -->
        <DxColumn
          :visible="false"
          :min-width="200"
          alignment="left"
          data-field="lamasatech_serial"
          :caption="$t('sitesAndDevices.lamasatechSerial')"
          :allowFiltering="false"
          :allowHeaderFiltering="true"
          :customize-text="defaultDataDisplay"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <!-- end::LamasaTech Serial -->

        <!-- start::Mac Address -->
        <DxColumn
          :visible="false"
          :min-width="150"
          alignment="left"
          data-field="mac_address"
          :caption="$t('sitesAndDevices.macAddress')"
          :allowFiltering="false"
          :allowHeaderFiltering="true"
          :customize-text="defaultDataDisplay"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <!-- end::Mac Address -->

        <!-- start::Status -->
        <DxColumn
          :min-width="150"
          alignment="left"
          data-field="kiosk_sync_infs"
          :caption="$t('common.status')"
          :allowFiltering="false"
          :allowHeaderFiltering="true"
          :calculate-cell-value="statusCell"
          cell-template="kiosk-status-template"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <template #kiosk-status-template="{ data }">
          <template>
            <div v-if="data.value == '-'">-</div>

            <div v-else-if="data.value == 'Online'" class="online-kiosk-style">
              {{ data.value }}
            </div>

            <div
              v-else-if="data.value === 'Not Synced'"
              class="notsynced-kiosk-style"
            >
              {{ data.value }}
            </div>
            <!-- <div v-else-if="data.value[0] == 'Offline'" class = "offline-kiosk-style">
              {{data.value}}
            </div> -->

            <div v-else class="offline-kiosk-style">
              {{ data.value }}
            </div>
          </template>
        </template>
        <!-- end::Status -->

        <!-- start::Printer -->
        <DxColumn
          :min-width="180"
          alignment="left"
          data-field="device_plugins.name"
          :caption="$t('common.printer')"
          :allowFiltering="false"
          :allowHeaderFiltering="true"
          :calculate-cell-value="printerCell"
          cell-template="printer-template"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <template #printer-template="{ data }">
          <div>
            <span
              v-if="
                data.value && data.value.toLowerCase().includes('not connected')
              "
              class="offline-kiosk-style"
            >
              {{ data.value }}
            </span>
            <div v-else-if="data.value && data.value.includes('Connected')">
              <span class="online-kiosk-style d-inline-block">
                {{ data.value.split(" ")[0] }}
              </span>
              <span>
                ({{
                  (data.data &&
                    data.data.device_plugins &&
                    data.data.device_plugins.find(
                      (elem) =>
                        elem.type && elem.type.toLowerCase() == "printer"
                    ).name) ||
                  "Printer"
                }})</span
              >
            </div>
            <span v-else>{{ data.value }}</span>
          </div>
        </template>
        <!-- end::Printer -->

        <!-- start:: geofencing -->
        <DxColumn
          :width="250"
          data-field="geofencing"
          :caption="$t('sitesAndDevices.geofencing')"
          :allow-header-filtering="true"
          :allow-filtering="false"
          :filter-operations="allowedOperations"
          :calculate-cell-value="displayGeofencing"
          :allow-reordering="true"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>

        <!-- start:: AreaQrCode -->
        <DxColumn
          :width="200"
          data-field="area_qr_code"
          :caption="$t('sitesAndDevices.areaQrCode')"
          :allow-header-filtering="false"
          :allow-filtering="false"
          cell-template="qrCodeTemplate"
          :allow-reordering="true"
        />

        <!-- start:: .EXE File -->
        <DxColumn
          :width="200"
          data-field="area_exe_file"
          :caption="$t('sitesAndDevices.areaActions.exeFile')"
          :allow-header-filtering="false"
          :allow-filtering="false"
          cell-template="exeFileTemplate"
          :allow-reordering="true"
          :visible="false"
        />

        <!-- start:: No of areas -->
        <DxColumn
          data-field="areasCount"
          :min-width="150"
          :caption="$t('sitesAndDevices.noOfAreas')"
          :customize-text="areaCountDisplay"
          :filter-operations="allowedOperations"
          :allow-filtering="true"
          :allow-reordering="true"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <!-- end:: No of areas -->

        <!-- start:: No of Kiosks -->
        <DxColumn
          :min-width="150"
          alignment="left"
          data-field="kioskCount"
          :caption="$t('sitesAndDevices.noOfDevices')"
          :customize-text="kioskCountDisplay"
          :allow-reordering="true"
          :filter-operations="allowedOperations"
          :allow-filtering="true"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <!-- end:: No of Kiosks -->

        <!-- start::Actions -->
        <DxColumn
          :min-width="150"
          alignment="left"
          id="custom-kioskDropDown"
          css-class="select-actions custom-kioskDropDown"
          :calculate-cell-value="actionCellData"
          :caption="$t('common.grid.actions')"
          :width="200"
          :allow-filtering="false"
          :allow-exporting="false"
          :allow-editing="false"
          :visible="true"
          cell-template="action-cell"
          :allow-reordering="true"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>

        <template #action-cell="{ data }">
          <Actions
            :data="data.value.data"
            :type="data.value.type"
            :loading="loading"
            @createArea="createArea"
            @updateArea="updateArea"
            @updateKioskSettings="updateKioskSettings"
            @moveArea="moveArea"
            @addKiosk="addKiosk"
            @moveSingleKiosk="moveSingleKiosk"
            @moveMultipleKiosk="moveMultipleKiosk"
            @changeKioskJourney="changeKioskJourney"
            @kioskUpdated="kioskUpdated"
          />
        </template>
        <!-- end::Actions -->
      </DxTreeList>
    </section>

    <!-- start::Delete site modal -->
    <b-modal id="deleteSite" scrollable hide-footer hide-header size="md">
      <DeleteSite :loading="loading" @deleteSiteFromList="deleteSiteFromList" />
    </b-modal>
    <!-- end::Delete site modal -->

    <!-- start::Delete area modal -->
    <b-modal id="deleteArea" scrollable hide-footer hide-header size="md">
      <div class="delete-user-type-wrapper">
        <h4 class="allareakiosk-header">
          {{ $t("sitesAndDevices.areaActions.deleteArea") }}
        </h4>
        <p class="custom-Question">
          Are you sure you want to
          <strong class="bold-txt">"Delete"</strong> the area "{{
            getModalInfo ? getModalInfo.name : ""
          }}"?
        </p>
        <p class="confirmation-msg">
          {{ $t("sitesAndDevices.notes.onAreaDelete") }}
        </p>

        <div class="actionsline-inside"></div>
        <div class="actions-btns">
          <button
            type="submit"
            class="submit-btn btn btn-primary add-submit"
            size="md"
            @click="deleteAreaFromList(getModalInfo.id)"
          >
            Delete
          </button>
          <button
            class="btn btn-outline-danger cancel-reject"
            type="button"
            @click="$bvModal.hide('deleteArea')"
          >
            Cancel
          </button>
        </div>
      </div>
    </b-modal>
    <!-- end::Delete area modal -->

    <!-- start::Delete kiosk modal -->
    <b-modal id="deleteKiosk" scrollable hide-footer hide-header size="md">
      <div class="delete-user-type-wrapper">
        <h4 class="allareakiosk-header">De-register Kiosk</h4>

        <p class="custom-Question">
          Are you sure you want to
          <strong class="bold-txt">"De-register"</strong>the kiosk "{{
            getModalInfo ? getModalInfo.name : ""
          }}"?
        </p>
        <p class="confirmation-msg">
          De-registering a kiosk will delete all data stored on it.
        </p>

        <div class="actionsline-inside"></div>
        <div class="actions-btns">
          <button
            type="submit"
            class="submit-btn btn btn-primary add-submit"
            size="md"
            @click="$bvModal.hide('deleteKiosk')"
          >
            Cancel
          </button>
          <button
            class="btn btn-outline-danger cancel-reject"
            type="button"
            @click="deleteKioskFromList(getModalInfo.id)"
          >
            De-register
          </button>
        </div>
      </div>
    </b-modal>
    <!-- end::Delete kiosk modal -->
    <!-- upgrade message  -->
    <b-modal id="upgradeMessage" hide-header hide-footer>
      <template>
        <div class="d-flex justify-content-center mb-3">
          <img
            src="@/assets/images/logo-lg.svg"
            class="unselectable"
            alt
            width="30%"
          />
        </div>
        <p class="text-center my-5" v-html="$t('sitesAndDevices.standaloneNote')"/>
        <div class="d-flex justify-content-end">
          <button
            class="btn btn-primary"
            @click="$bvModal.hide('upgradeMessage')"
          >
            {{ $t('common.gotIt')}}
          </button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="exportingProgress"
      hide-footer
      hide-header
      size="lg"
      :scrollable="false"
    >
      <ExportProgress />
    </b-modal>

    <ContextMenu ref="menu" :model="contextMenuItems" appendTo="body" />
  </div>
</template>

<script>
import Actions from "@/components/sites/ActionsForTreeList";
import { mapGetters, mapActions } from "vuex";
import { default as Button } from "devextreme-vue/button";
import AlertFoundActiveSession from "@/components/emergency/AlertFoundActiveSession";
import AddSiteAreaKioskDropdown from "./AddSiteAreaKioskDropdown.vue";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import PageHeader from "@/components/page-header";
import { newSitesColumns } from "@/utils/dataSource";
import ExportProgress from "@/components/grid/ExportProgress";
import sitesTreelistDataSource from "@/utils/mixins/treeListDataSource.js";
import sitesService from "@/services/sites";
import kiosksService from "@/services/kiosks";
import journeyService from "@/services/journey";
import DeleteSite from "./DeleteSiteModal";

import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import QRCode from "qrcode-generator";
import logoPdf from "@/assets/images/logo-pdf.png";
import { areaModes } from "@/utils/Constants";
import ContextMenu from "primevue/contextmenu";
import { hideColumnChooserOnBackdrop } from "@/utils/mixins/hideColumnChooserOnBackdrop";

import {
  DxTreeList,
  DxColumn,
  DxColumnChooser,
  DxHeaderFilter,
  DxToolbar,
  DxItem,
  DxFilterRow,
  // DxPaging,
  DxPager,
  DxScrolling,
  DxLoadPanel,
  //   DxSelection,
  //   DxLookup,
  DxStateStoring,
} from "devextreme-vue/tree-list";

export default {
  title: "Sites",
  mixins: [sitesTreelistDataSource, hideColumnChooserOnBackdrop],
  components: {
    DxTreeList,
    DxColumn,
    DxColumnChooser,
    DxHeaderFilter,
    DxToolbar,
    DxItem,
    Button,
    DxLoadPanel,
    DxFilterRow,
    // DxPaging,
    Actions,
    DxPager,
    DxScrolling,
    AddSiteAreaKioskDropdown,
    PageHeader,
    DxDropDownButton,
    // DxSelection,
    // DxLookup,
    AlertFoundActiveSession,
    DxStateStoring,
    ExportProgress,
    DeleteSite,
    ContextMenu,
  },
  data() {
    return {
      gridEmptyMessage: this.$t("common.grid.loadingData"),
      qrImageData: "",
      rowId: "",
      exefileRowId: "",
      downloadLoading: false,
      loading: false,
      dataSource: [],
      readMore: {},
      buttonData: ["PDF", "Excel", "CSV"],
      expandedRowKeys: [],
      allowedPageSizes: [10, 25, 40],
      sitesAndAreasRefName: "sitesAndAreasTreelist",
      domain_env: process.env.VUE_APP_DOMAIN,
      pre_reg_url: process.env.VUE_APP_PRE_REGISTRATION_URL,
      allowedOperations: ["contains"],
      showClearAll: false,
      columnsFilters: [],
      contextMenuItems: [],
      isAllExpanded: [],
      isAllCollapsed: [],
      isAllSitesCollapsed: [],
      rtlEnabled: false,
    };
  },
  watch: {
    isLoading(status) {
      if (status) {
        this.treelist.beginCustomLoading();
      } else {
        this.treelist.endCustomLoading();
      }
    },
    getExportProgessAppearance(value) {
      value && this.$bvModal.show("exportingProgress");
    },
  },
  methods: {
    ...mapActions("grid", [
      "createTableHeaders",
      "onTableHeader",
      "updateTableHeaders",
      "exportJobBE",
    ]),
    ...mapActions("kiosks", ["deleteKiosk"]),
    ...mapActions("sites", ["deleteArea", "downloadAreaExeFile"]),
    ...mapActions("modal", ["setData"]),
    ...mapActions("daemon", [
      // "updateApp",
      "remoteShowScreen",
      "kioskLogging",
      // "forceResyncWithLogs",
      "pullDatabase",
    ]),
    traverseChildren(children, action) {
      children.forEach((child) => {
        if (action == "collapse") this.treelist.collapseRow(child.key);
        else if (action == "expand") this.treelist.expandRow(child.key);

        if (child.hasChildren) {
          this.traverseChildren(child.children, action);
        }
      });
    },
    collapseAll() {
      this.treelist.getRootNode().children.forEach((node) => {
        this.treelist.collapseRow(node.key);
        if (node.hasChildren) {
          this.traverseChildren(node.children, "collapse");
        }
      });
    },
    expandAll() {
      this.treelist.getRootNode().children.forEach((node) => {
        this.treelist.expandRow(node.key);
        if (node.hasChildren) {
          this.traverseChildren(node.children, "expand");
        }
      });
    },
    // sets the position of the context menu element on the page based on the coordinates of a click event
    onItemContextMenu(e) {
      this.contextMenuItems = [];
      const nodeData = e.row?.data;

      if (!nodeData) return;
      console.log("onItemContextMenu", nodeData.id);

      if (nodeData?.dataType == "site" && !this.disabledAreaAction) {
        this.contextMenuItems.push(
          {
            label: this.$t("sitesAndDevices.siteActions.editSite"),
            class: "context-menu-items",
            command: () => {
              this.setData(nodeData);
              this.$bvModal.show("addSite_");
            },
          },
          {
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.siteActions.deleteSite"),
            class: "custom-red-delete",
            command: () => {
              this.setData(nodeData);
              this.$bvModal.show("deleteSite");
            },
          },
          {
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.siteActions.addArea"),
            class: "context-menu-items",
            command: () => {
              this.setData({
                ...nodeData,
                areaMode: areaModes.NORMAL,
                isEditArea: false,
                modalId: `addAreaFromSite_${nodeData.id}ConfirmModal`,
              });
              this.$bvModal.show(`addAreaFromSite_${nodeData.id}ConfirmModal`);
            },
          },
          {
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.siteActions.addRemoteArea"),
            class: "context-menu-items",
            command: () => {
              this.setData({
                ...nodeData,
                areaMode: areaModes.REMOTE,
                isEditArea: false,
                modalId: `addAreaFromSite_${nodeData.id}ConfirmModal`,
              });
              this.$bvModal.show(`addAreaFromSite_${nodeData.id}ConfirmModal`);
            },
          },
          {
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.siteActions.kioskSettings"),
            class: "context-menu-items",
            command: () => {
              this.setData({
                ...nodeData,
                modalId: `multipleKioskSettings_${nodeData.id}`,
              });
              this.$bvModal.show(`multipleKioskSettings_${nodeData.id}`);
            },
          }
        );
      } else if (nodeData.dataType == "area") {
        console.log('hi');
        this.contextMenuItems.push(
          {
            visible: !nodeData.loginMode.toLowerCase().includes("remote"),
            label: this.$t("sitesAndDevices.areaActions.editArea"),
            disabled: this.disabledAreaAction,
            class: "context-menu-items",
            command: () => {
              this.setData({
                ...nodeData,
                areaMode: areaModes.NORMAL,
                isEditArea: true,
                modalId: `addAreaFromSite_${nodeData.id}ConfirmModal`,
              });
              this.$bvModal.show(`addAreaFromSite_${nodeData.id}ConfirmModal`);
            },
          },
          {
            visible: nodeData.loginMode.toLowerCase().includes("remote"),
            label: this.$t("sitesAndDevices.areaActions.editArea"),
            disabled: this.disabledAreaAction,
            class: "context-menu-items",
            command: () => {
              this.setData({
                ...nodeData,
                areaMode: areaModes.REMOTE,
                isEditArea: true,
                modalId: `addAreaFromSite_${nodeData.id}ConfirmModal`,
              });
              this.$bvModal.show(`addAreaFromSite_${nodeData.id}ConfirmModal`);
            },
          },
          {
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.areaActions.moveArea"),
            visible: !nodeData.loginMode.toLowerCase().includes("remote"),
            disabled: this.disabledAreaAction,
            class: "context-menu-items",
            command: () => {
              this.setData({ ...nodeData, modalId: `moveArea_${nodeData.id}` });
              this.$bvModal.show(`moveArea_${nodeData.id}`);
            },
          },
          {
            separator: true,
            visible: !nodeData.loginMode.toLowerCase().includes("remote"),
          },
          // {
          //   label: this.$t("sitesAndDevices.areaActions.downloadExe"),
          //   visible: !nodeData.loginMode.toLowerCase().includes("remote"),
          //   disabled: this.disabledAreaAction,
          //   class: "context-menu-items",
          //   command: () => {
          //     this.generateAndDownloadAreaExeFile(nodeData);
          //   },
          // },
          // {
          //   visible: !nodeData.loginMode.toLowerCase().includes("remote"),
          //   separator: true,
          // },
          {
            label: this.$t("sitesAndDevices.areaActions.deleteArea"),
            class: "custom-red-delete",
            disabled: this.disabledAreaAction,
            command: () => {
              this.setData(nodeData);
              this.$bvModal.show("deleteArea");
            },
          },
          {
            separator: true,
            visible: !nodeData.loginMode.toLowerCase().includes("remote"),
          },
          {
            label: this.$t("sitesAndDevices.areaActions.addKiosk"),
            visible: !nodeData.loginMode.toLowerCase().includes("remote"),
            class: "context-menu-items",
            command: () => {
              this.setData({ ...nodeData, modalId: `addKiosk_${nodeData.id}` });
              this.$bvModal.show(`addKiosk_${nodeData.id}`);
            },
          },
          {
            visible: !nodeData.loginMode.toLowerCase().includes("remote"),
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.siteActions.kioskSettings"),
            visible: !nodeData.loginMode.toLowerCase().includes("remote"),
            disabled: this.disabledAreaAction,
            class: "context-menu-items",
            command: () => {
              this.setData({
                ...nodeData,
                modalId: `multipleKioskSettings_${nodeData.id}`,
              });
              this.$bvModal.show(`multipleKioskSettings_${nodeData.id}`);
            },
          }
        );
      } else if (nodeData.dataType == "kiosk") {
        this.contextMenuItems.push(
          {
            label: this.$t("sitesAndDevices.kioskActions.openDoor"),
            class: "context-menu-items",
            command: () => {
              this.setData({
                kioskInfo: {
                  kiosk_name: nodeData.name,
                  mac_address: nodeData.mac_address,
                },
                actionType: "open_door",
              });
              this.$bvModal.show(`kioskActions${nodeData.mac_address}`);
            },
          },
          {
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.kioskActions.restartKiosk"),
            class: "context-menu-items",
            command: () => {
              this.setData({
                kioskInfo: {
                  kiosk_name: nodeData.name,
                  mac_address: nodeData.mac_address,
                },
                actionType: "restart_kiosk",
              });
              this.$bvModal.show(`kioskActions${nodeData.mac_address}`);
            },
          },
          {
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.kioskActions.restartApp"),
            class: "context-menu-items",
            command: () => {
              this.setData({
                kioskInfo: {
                  kiosk_name: nodeData.name,
                  mac_address: nodeData.mac_address,
                },
                actionType: "restart_app",
              });
              this.$bvModal.show(`kioskActions${nodeData.mac_address}`);
            },
          },
          {
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.kioskActions.screenshot"),
            class: "context-menu-items",
            command: () => {
              this.remoteShowScreen({
                kiosk_name: nodeData.name,
                mac_address: nodeData.mac_address,
              });
            },
          },
          {
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.siteActions.kioskSettings"),
            disabled: this.getPackageType == "Standalone",
            class: "context-menu-items",
            command: () => {
              this.setData(nodeData);
              this.$bvModal.show(`kioskSetting_${nodeData.id}`);
            },
          },
          {
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.kioskActions.installApp"),
            class: "context-menu-items",
            command: () => {
              this.setData(nodeData);
              this.$bvModal.show(`installApp_${nodeData.id}`);
            },
          },
          {
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.kioskActions.kioskInfo"),
            class: "context-menu-items",
            command: () => {
              this.setData(nodeData);
              this.$bvModal.show(`kioskInfo_${nodeData.id}`);
            },
          },
          {
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.kioskActions.previewLogs"),
            class: "context-menu-items",
            command: () => {
              this.setData(nodeData);
              this.$bvModal.show(`kioskLogs_${nodeData.id}`);
            },
          },
          {
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.kioskActions.getLogs"),
            visible: this.userEmail == "lt_techteam@visipoint.com",
            command: async () => {
              await this.kioskLogging({
                kiosk_name: nodeData.name,
                mac_address: nodeData.mac_address,
              });
            },
          },
          {
            separator: true,
            visible: this.userEmail == "lt_techteam@visipoint.com",
          },
          {
            label: this.$t("sitesAndDevices.kioskActions.getDatabase"),
            visible: this.userEmail == "lt_techteam@visipoint.com",
            command: async () => {
              await this.pullDatabase({
                kiosk_name: nodeData.name,
                mac_address: nodeData.mac_address,
              });
            },
          },
          {
            separator: true,
            visible: this.userEmail == "lt_techteam@visipoint.com",
          },
          {
            label: this.$t("sitesAndDevices.kioskActions.changeJourney"),
            class: "context-menu-items",
            command: () => {
              this.setData({
                ...nodeData,
                modalId: `changeJourney_${nodeData.id}`,
              });
              this.$bvModal.show(`changeJourney_${nodeData.id}`);
            },
          },
          {
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.kioskActions.moveKiosk"),
            disabled: this.disabledAreaAction,
            class: "context-menu-items",
            command: () => {
              this.setData(nodeData);
              this.$bvModal.show(`moveKiosk_${nodeData.id}`);
            },
          },
          {
            separator: true,
          },
          {
            label: this.$t("sitesAndDevices.kioskActions.deRegister"),
            class: "custom-red-delete",
            command: () => {
              this.setData({
                name:
                  nodeData.name.charAt(0).toUpperCase() +
                  nodeData.name.slice(1),
                id: nodeData.id,
                type: "kiosk",
              });
              this.$bvModal.show("deleteKiosk");
            },
          }
        );
      }

      this.$nextTick(() => {
        if (
          (!this.disabledAreaAction && nodeData.dataType == "site") ||
          nodeData.dataType == "area" ||
          nodeData.dataType == "kiosk"
        )
          this.$refs.menu.show(e.event);
      });
    },
    async fetchAndEncodeImage(url) {
      try {
        const timestamp = new Date().getTime();
        const imageUrl = `${url}?timestamp=${timestamp}`;

        // Fetch the image data from S3
        const response = await axios.get(imageUrl, {
          responseType: "arraybuffer",
        });

        // Convert the image data to a base64 string
        const base64Data = Buffer.from(response.data, "binary").toString(
          "base64"
        );

        // Return the base64-encoded image data
        return `data:image/png;base64,${base64Data}`;
      } catch (error) {
        console.error("Error fetching image:", error);
        return null;
      }
    },
    async downloadPDF(id, qrCodeUrl, areaName, journey) {
      this.rowId = id;
      console.log("qrCodeUrl", qrCodeUrl, journey);
      const pdf = new jsPDF();

      const qrData = qrCodeUrl; // Example QR code data
      const qr = QRCode(0, "M"); // Create QR code object
      qr.addData(qrData);
      qr.make(); // Generate QR code
      const qrImageData = qr.createDataURL();
      const compLogo = journey.logo || this.currentEntity.logo;
      let embeddedImageUrl = "";
      if (compLogo) {
        embeddedImageUrl = await this.fetchAndEncodeImage(compLogo);
      }

      let content = "";
      if (this.getLanguage == "ar")
        content = `
                  <html>
                    <div class="container" style="width:160px;background:#ffffff;margin-inline-end:auto;margin-inline-start:25px;margin-bottom:40px; margin-top: 30px;font-family:sans-serif">
                        ${
                          embeddedImageUrl
                            ? `
                          <div style="width: 20px; height:20px;margin-bottom:20px;margin-inline-end:auto;margin-inline-start:auto;border-radius:100%;background:#D9D9D9;margin-top:30px;display:flex;align-items:center;justify-content:center;">
                            <img style="width: 20px; height:20px;margin-bottom:5px;margin-inline-end:auto;margin-inline-start:auto;border-radius:100%;background:#D9D9D9;margin-top:5px;display:flex;align-items:center;justify-content:center;" src="${embeddedImageUrl}" alt="-comp-logo" /> 
                          </div>
                        `
                            : `
                          <div style="width: 30px; height:10px;margin-bottom:30px;margin-inline-end:auto;margin-inline-start:auto">
                            <img src="${logoPdf}" alt="-visipoint-logo" />
                          </div>
                        `
                        }
                      
                      <p style="font-size:7px;margin-inline-end:8px;text-align:center;font-weight:600; font-family: sans-serif;margin-bottom:0px;color:black;line-height: 5px;white-space: nowrap;">Please scan this QR code to check into</p>
                      <p style="font-size:7px;margin-inline-end:8px;text-align:center;font-weight:600; font-family: sans-serif;margin-bottom:10px;color:black;line-height: 5px;margin-top:5px;white-space: nowrap;">."${areaName}"</p>
                    <div  style="width: 120px; height:120px;border: solid #F3F3F3 5px;border-radius:1px;margin:5px auto">
                      <div style="width: 110px; height:110px;border:#000000 solid 2px;border-radius:1px;margin:auto">
                        <img src=${qrImageData} />
                      </div>
                    </div>
                    <p style="font-size:6px;text-align:center;font-weight:700; font-family: sans-serif;color:black;line-height: 5px ;margin-bottom:0px;white-space: nowrap;">,Regards</p>
                    <p style="font-size:6px;text-align:center;font-weight:700; font-family: sans-serif;line-height: 5px;color:black;margin-top:10px;white-space: nowrap;">${
                      this.currentEntity.name
                    }</p>
                    </div>
                  </html>
                `;
      else
        content = `
                  <html>
                    <div class="container" style="width:160px;background:#ffffff;margin-inline-end:auto;margin-inline-start:25px;margin-bottom:40px; margin-top: 30px;font-family:sans-serif">
                        ${
                          embeddedImageUrl
                            ? `
                          <div style="width: 20px; height:20px;margin-bottom:20px;margin-inline-end:auto;margin-inline-start:auto;border-radius:100%;background:#D9D9D9;margin-top:30px;display:flex;align-items:center;justify-content:center;">
                            <img style="width: 20px; height:20px;margin-bottom:5px;margin-inline-end:auto;margin-inline-start:auto;border-radius:100%;background:#D9D9D9;margin-top:5px;display:flex;align-items:center;justify-content:center;" src="${embeddedImageUrl}" alt="-comp-logo" /> 
                          </div>
                        `
                            : `
                          <div style="width: 30px; height:10px;margin-bottom:30px;margin-inline-end:auto;margin-inline-start:auto">
                            <img src="${logoPdf}" alt="-visipoint-logo" />
                          </div>
                        `
                        }
                      
                      <p style="font-size:7px;margin-inline-start:8px;text-align:center;font-weight:600; font-family: sans-serif;margin-bottom:0px;color:black;line-height: 5px;white-space: nowrap;">Please scan this QR code to check into</p>
                      <p style="font-size:7px;margin-inline-start:8px;text-align:center;font-weight:600; font-family: sans-serif;margin-bottom:10px;color:black;line-height: 5px;margin-top:5px;white-space: nowrap;">"${areaName}".</p>
                    <div  style="width: 120px; height:120px;border: solid #F3F3F3 5px;border-radius:1px;margin:5px auto">
                      <div style="width: 110px; height:110px;border:#000000 solid 2px;border-radius:1px;margin:auto">
                        <img src=${qrImageData} />
                      </div>
                    </div>
                    <p style="font-size:6px;text-align:center;font-weight:700; font-family: sans-serif;color:black;line-height: 5px ;margin-bottom:0px;white-space: nowrap;">Regards,</p>
                    <p style="font-size:6px;text-align:center;font-weight:700; font-family: sans-serif;line-height: 5px;color:black;margin-top:10px;white-space: nowrap;">${
                      this.currentEntity.name
                    }</p>
                    </div>
                  </html>
                `;

      console.log("qrImageData", qrImageData);

      pdf.html(content, {
        x: this.getLanguage == "ar" ? 210 : 0,
        callback: () => {
          // pdf.addImage(qrImageData, 'JPEG', 50, 50, 50, 50); // imageData, format, x, y, width, and height.
          pdf.save("qrCode.pdf");
          this.downloadLoading = false;
          this.rowId = null;
        },
      });
    },
    customizeHeaderFilter(options) {
      options.dataSource.postProcess = function (items) {
        items = items.filter((item) => item.value && item.value !== "-");
        if (this.pageIndex() === 0) {
          items = items.slice(0);
          // items.unshift({ value: "-", text: "-" });
        }
        return items;
      };
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    displayDescription(e) {
      return e.description ? e.description : "-";
    },
    displayGeofencing(e) {
      const isRemoteArea =
        e.loginMode == "remote_checkIn_only" ||
        e.loginMode == "remote_signIn_signOut";

      return e.is_geofencing_enabled || (e.geofencing && !isRemoteArea)
        ? this.$t("common.on")
        : e.is_geofencing_enabled == 0 || (e.geofencing == 0 && !isRemoteArea)
        ? this.$t("common.off")
        : "-";
    },
    statusCell(e) {
      if (e.dataType == "kiosk") {
        const status = e.kiosk_sync_infs ? e.kiosk_sync_infs.status : null;
        if (status == 0) {
          return `${this.$t("sitesAndDevices.offlineSince")} ${
            e.kiosk_sync_infs.last_sync
          }`;
        } else if (status == 1) {
          return this.$t("sitesAndDevices.online");
        } else if (status === null) {
          return this.$t("sitesAndDevices.notSynced");
        }
      } else {
        return "-";
      }
    },
    printerCell(e) {
      if (!e.kiosk_sync_infs || e?.kiosk_sync_infs.status != "1") return "-";
      else if (e.kiosk_sync_infs.status == "1") {
        let printerObject = e?.device_plugins?.find(
          (elem) => elem.type?.toLowerCase() == "printer"
        );
        if (!printerObject || printerObject?.status == "0")
          return this.$t("sitesAndDevices.notConnected");
        else if(printerObject?.status == "1") return printerObject?.name;
        // else if(printerObject?.status == "1")
        //   return this.$t("sitesAndDevices.connected");
        // else
        //   return `${this.$t("sitesAndDevices.notConnected")} (${
        //     printerObject?.name
        //   })`;
      }
      return "-";
    },
    emailCell(e) {
      return e.reception_email ? e.reception_email : "-";
    },
    onEditorPreparing(e) {
      if (e.parentType == "filterRow") {
        e.editorOptions.placeholder = this.$t("common.grid.search");
      }
    },
    actionCellData(e) {
      return { type: e.dataType, data: e };
    },
    contentReady(e) {
      let sortedExp = this.getSortedColumns();
      console.log("sortedExp", sortedExp);
      let filterExp = e.component.getCombinedFilter();
      if (filterExp || sortedExp) {
        this.showClearAll = true;
      } else {
        this.showClearAll = false;
      }
      this.setColumnChooserPosition();

      this.isAllExpanded = [];
      this.isAllCollapsed = [];
      this.isAllSitesCollapsed = [];
      this.checkIfAllSitesAreCollapsed();
      this.isAllNodesExpanded("expand");
      this.isAllNodesExpanded("collapse");
    },
    checkIfAllSitesAreCollapsed() {
      this.treelist.getRootNode()?.children?.forEach((site) => {
        this.isAllSitesCollapsed.push(this.treelist.isRowExpanded(site.key));
      });
    },
    isAllNodesExpanded(actionType) {
      this.treelist.getRootNode().children.forEach((node) => {
        if (node.hasChildren) {
          if (actionType == "expand")
            this.isAllExpanded.push(this.treelist.isRowExpanded(node.key));
          else if (actionType == "collapse")
            this.isAllCollapsed.push(!this.treelist.isRowExpanded(node.key));

          this.checkChildrenNode(node.children, actionType);
        }
      });
    },
    checkChildrenNode(children, action) {
      children.forEach((child) => {
        if (child.hasChildren) {
          if (action == "collapse")
            this.isAllCollapsed.push(!this.treelist.isRowExpanded(child.key));
          else if (action == "expand")
            this.isAllExpanded.push(this.treelist.isRowExpanded(child.key));

          this.checkChildrenNode(child.children, action);
        }
      });
    },
    getSortedColumns() {
      let allColumns = Array.from(
        Array(this.treelist.columnCount()).keys()
      ).map((index) => this.treelist.columnOption(index));
      allColumns = allColumns.find((col) => col.sortIndex != null);
      return allColumns;
    },
    setColumnChooserPosition() {
      var columnChooserView = this.treelist.getView("columnChooserView");

      if (!columnChooserView._popupContainer) {
        columnChooserView._initializePopupContainer();
        columnChooserView.render();
      }

      columnChooserView._popupContainer.option("position", {
        of: this.treelist.element(),
        my: this.getLanguage === "en" ? "left top" : "right top",
        at: this.getLanguage === "en" ? "left top" : "right top",
        offset: "0 50",
      });
    },
    clearFilter() {
      this.treelist.clearFilter("row");
      this.treelist.clearFilter("header");
      this.treelist.clearSorting();
      this.showClearAll = false;
    },
    serverSideExport(e) {
      this.exportJobBE({
        filterBy: this.columnsFilters,
        orderBy: "",
        type: e.itemData.toLowerCase(),
        gridName: "site",
      });
    },
    areaCountDisplay(e) {
      return e.valueText == "0" || !e.valueText ? "-" : e.valueText;
    },
    kioskCountDisplay(e) {
      return e.valueText == "0" || !e.valueText ? "-" : e.valueText;
    },
    loginModeDisplay(e) {
      switch (e.value) {
        case "signIn_signOut":
          return this.$t("common.signInOut");
        case "checkIn_only":
          return this.$t("common.checkInOnly");
        case "remote_checkIn_only":
          return this.$t("common.remoteCheckInOnly");
        case "remote_signIn_signOut":
          return this.$t("common.remoteSignInOut");
        default:
          "";
      }
      return e.value ? e.value : "-";
    },
    kioskSignInOutModeDisplay(e) {
      switch (e.value) {
        case "signIn_signOut":
          return this.$t("common.signInOut");
        case "checkIn_only":
          return this.$t("common.checkInOnly");
        case "remote_checkIn_only":
          return this.$t("common.remoteCheckInOnly");
        case "remote_signIn_signOut":
          return this.$t("common.remoteSignInOut");
        default:
          "";
      }
      return e.value ? e.value : "-";
    },
    defaultDataDisplay(e) {
      return e.value ? e.value : "-";
    },
    preRegUrl(e) {
      if (e.pre_registration_url) {
        return `${this.domain_env}/${this.pre_reg_url}/${e.pre_registration_url}`;
      }
      return "-";
    },
    autoSignOutModeDisplay(e) {
      if (
        !e.settings ||
        !e.settings.length ||
        (e.settings && !e.isAutoSignOut) ||
        e.dataType == "kiosk" ||
        e.dataType == "site"
      ) {
        return "-";
      }
      for (let indx in e.settings) {
        if (e.settings[indx].id == 82) {
          if (
            e.settings[indx].pivot.value == "signIn_signOut" ||
            e.settings[indx].pivot.value == "remote_signIn_signOut"
          ) {
            let areaModeSetting = e.settings.find((elem) => elem.id == 84);
            if (areaModeSetting.pivot.value == "at_midnight")
              return this.$t("sitesAndDevices.autoSignOutMode.atMidnight");
            else if (areaModeSetting.pivot.value == "after_24_hours")
              return this.$t("sitesAndDevices.autoSignOutMode.after24Hours");
          }
          return "-";
        }
      }
    },
    async kioskUpdated(modalId) {
      this.onActionSubmit(null, modalId);
    },
    async changeKioskJourney(kioskData, modalId) {
      await journeyService.changeJourney(kioskData);
      this.onActionSubmit("Journey Changed", modalId);
    },
    async moveSingleKiosk(kioskData, modalId) {
      await kiosksService.moveKisok(kioskData);
      this.onActionSubmit("Kiosk Moved", modalId);
    },
    async moveMultipleKiosk(kioskData, modalId) {
      await kiosksService.moveMultipleKiosks(kioskData);
      this.onActionSubmit("Kiosks Moved", modalId);
    },
    async addKiosk(kioskData, modalId) {
      try {
        this.loading = true;
        await kiosksService.addKiosk(kioskData);
        this.onActionSubmit("Kiosk Added", modalId);
      } catch (err) {
        this.loading = false;
        this.onActionSubmit(
          Object.values(err.data.errors).join("\r\n"),
          modalId,
          true
        );
      }
    },
    async moveArea(areaData, modalId) {
      await sitesService.moveArea(areaData);
      this.onActionSubmit("Area Moved", modalId);
    },
    async updateKioskSettings(kioskData, modalId) {
      await kiosksService.updateKiosksSettings(kioskData);
      this.onActionSubmit("Kiosk Settings Updated", modalId);
    },
    async updateArea(areaData, modalId) {
      if (areaData.description?.length >= 37) this.showMore(areaData.id);
      else this.showLess(areaData.id);
      await sitesService.updateArea(areaData);
      this.onActionSubmit("Area Updated", `editAreaInSite_${modalId}`);
    },
    async createArea(areaData, modalId) {
      await sitesService.createArea(areaData);
      this.onActionSubmit("Area Added", modalId);
    },
    async deleteSiteFromList(siteId) {
      try {
        this.loading = true;
        await sitesService.deleteSite(siteId);
        this.onActionSubmit("Site Deleted", "deleteSite");
      } catch (err) {
        this.loading = false;
        this.onActionSubmit(err.data.message, "deleteSite", true);
      }
    },
    async onActionSubmit(toastMsg, modalId, isError = false) {
      if (toastMsg && !isError) {
        this.$toast.success(toastMsg);
        this.$bvModal.hide(modalId);
        await this.fetchDataSource();
      } else if (isError) this.$toast.error(toastMsg);
      else if (!isError) await this.fetchDataSource();
      this.loading = false;
    },
    deleteAreaFromList(areaId) {
      this.deleteArea(areaId).then(async () => {
        await this.fetchDataSource();
      });
      this.$bvModal.hide("deleteArea");
    },
    deleteRemoteAreaFromList(RemoteAreaId) {
      this.deleteRemoteArea(RemoteAreaId).then(async () => {
        await this.fetchDataSource();
      });
      this.$bvModal.hide("deleteRemoteArea");
    },
    deleteKioskFromList(kioskId) {
      this.deleteKiosk(kioskId).then(async () => {
        await this.fetchDataSource();
      });
      this.$bvModal.hide("deleteKiosk");
    },
    fetchTableHeaders() {
      this.onTableHeader({
        url: "/new-sites-areas-devices-grid",
        headers: newSitesColumns,
      });
    },
    async customLoad() {
      if (this.userEmail !== "lt_techteam@visipoint.com") {
        await this.onTableHeader({
          url: "/new-sites-areas-devices-grid",
        });
        let value = this.getTableHeaders;
        if (value) {
          for (let i = 0; i < value.columns.length; i++) {
            if (
              value.columns[i].dataField == "device_plugins.name" &&
              value.columns[i].visibleIndex >= 15
            ) {
              value.columns[i].visibleIndex = value.columns.length - 2;
            } else if (
              value.columns[i].dataField == "geofencing" &&
              value.columns[i].visibleIndex >= 15
            ) {
              value.columns[i].visibleIndex = 2;
            } else if (
              value.columns[i].dataField == "area_qr_code" &&
              value.columns[i].visibleIndex >= 15
            ) {
              value.columns[i].visibleIndex = 3;
            }
          }
        }
        return value;
      }
    },
    customSave(gridState) {
      if (this.userEmail !== "lt_techteam@visipoint.com") {
        gridState.pageIndex = 0;
        gridState.pageSize = 1000000;
        let value = JSON.stringify(gridState);
        value = value.replace(',"selectedRowKeys":[]', "");
        this.formatingFilterArr(value);
        if (!this.getTableHeaders) {
          this.createTableHeaders({
            url: "/new-sites-areas-devices-grid",
            headers: value,
            filters: "[]",
          });
        } else if (value != JSON.stringify(this.getTableHeaders)) {
          this.updateTableHeaders({
            url: "/new-sites-areas-devices-grid",
            headers: value,
            filters: "[]",
          });
        }
        console.log(
          "customSave values",
          value != JSON.stringify(this.getTableHeaders)
        );
      }
    },
    formatingFilterArr(arr) {
      let columns = [];
      arr = JSON.parse(arr);
      arr.columns.map((obj) => {
        if (obj.name != "Actions") {
          delete obj.width;
          delete obj.dataField;
          delete obj.dataType;
          delete obj.filterType;
          columns.push(obj);
        }
      });
      columns.sort((a, b) => {
        return a.visibleIndex - b.visibleIndex;
      });
      console.log("columns", columns);
      this.columnsFilters = columns;
    },
    async fetchDataSource() {
      this.gridEmptyMessage = await this.$t("common.grid.loadingData");
      this.dataSource = await this.fetchSitesWithAreasAndKiosks();
      this.gridEmptyMessage = this.$t("common.grid.noRecordsYet");
    },
    onDataErrorOccurred(e) {
      console.log("onDataErrorOccurred e", e);
      setTimeout(() => {
        let errorRow = document.querySelector(
          ".dx-treelist-headers .dx-error-message"
        );
        errorRow.innerHTML = this.$t("common.notes.anErrorOccurredGrid");
      }, 100);
    },
    generateAndDownloadAreaExeFile(area) {
      this.exefileRowId = area.id;
      this.downloadLoading = true;
      this.downloadAreaExeFile(area.id).then((res) => {
        // console.log("res", res);
        if (res.data && typeof res.data != "object") {
          // var str = res.data;
          const link = document.createElement("a");
          document.body.appendChild(link);
          link.href = res.data;
          link.click();
          console.log("link", link);
          document.body.removeChild(link);

          // URL.revokeObjectURL(link.href);
          this.$toast.success(res.message);
        } else {
          this.$toast.error(res.data?.original?.error);
        }
        this.downloadLoading = false;
        this.exefileRowId = null;
      });
    },
  },
  computed: {
    ...mapGetters("sites", ["getSitesWithAreasAndKiosks", "getLoader"]),
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("grid", ["getTableHeaders", "getExportProgessAppearance"]),
    ...mapGetters("authfack", ["userDetails", "currentEntity"]),
    ...mapGetters("emergency", ["getActiveSessionsCount"]),
    ...mapGetters("i18N", ["getLanguage"]),
    disabledAreaAction() {
      return (
        this.getPackageType == "Standalone" &&
        this.userEmail != "lt_techteam@visipoint.com"
      );
    },
    getPackageType() {
      const { currentEntity } = this;
      return currentEntity && currentEntity.package;
    },
    treelist() {
      return this.$refs[this.sitesAndAreasRefName].instance;
    },
    userEmail() {
      return this.userDetails && this.userDetails.email;
    },
    disableExpandAll() {
      return !this.isAllExpanded.some((item) => !item);
    },
    disableCollapseAll() {
      return !this.isAllCollapsed.some((item) => !item);
    },
    disableOnAllSitesCollapse() {
      return !this.isAllSitesCollapsed.some((item) => !!item);
    },
  },
  async mounted() {
    if (this.getLanguage == "ar") {
      this.rtlEnabled = true;
    }
    this.getPackageType == "Standalone" &&
      setTimeout(() => {
        this.$bvModal.show("upgradeMessage");
      }, 1500);

    this.treelist.beginCustomLoading();

    await this.fetchDataSource();

    this.hideColumnChooserOnBackdropFn();
    // Event listener for hiding column chooser
    // document.addEventListener("mousedown", (event) => {
    //   const isColumnChooser = event.composedPath().some((element) =>
    //     element?.matches?.(".dx-overlay-content")
    //   );
    //   if (!isColumnChooser) {
    //     this.treelist.hideColumnChooser();
    //   }
    // })
  },
};
</script>

<style scoped lang="scss">
.spinner-border {
  height: 15px;
  width: 15px;
  color: #103f5e !important;
  margin-inline-end: 8px;
  font-size: 9px;
}
.sites-header {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #495057;
  margin-top: 29px;
  margin-inline-start: 9px;
  margin-bottom: 29px;
  margin-inline-end: 31px;
}

.read_more {
  width: 69px;
  height: 17px;
  inset-inline-start: 721px;
  top: 503px;

  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  text-decoration-line: underline !important;
  color: #2680eb;
}

.offline-kiosk-style {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;

  /* #F46A6A */

  color: #f46a6a;
}
.online-kiosk-style {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 0px !important;
  /* #34C38F */

  color: #34c38f;
}
.notsynced-kiosk-style {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;

  color: #495057;
}
div#sitesAndAreasTreelist {
  .download-pdf.dx-template-wrapper {
    color: #2680eb;
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    cursor: pointer !important;
    span {
      cursor: pointer !important;
    }
  }
  .download-pdf.dx-template-wrapper span:read-only {
    cursor: pointer !important;
  }
}
</style>
<style lang="scss">
.html2pdf__overlay {
  opacity: 0;
}
[id*="addAreaFromSite"] .modal-content {
  top: unset !important;
}
.sitesGridHeight .dx-treelist-container {
  height: calc(100vh - 197px);
}
.sitesGridHeightWithAlert .dx-treelist-container {
  height: calc(100vh - 243px);
}
:dir(rtl) div#deleteSite div#deleteSite___BV_modal_content_ {
  inset-inline-start: -50%;
}
:dir(ltr) div#deleteSite div#deleteSite___BV_modal_content_ {
  inset-inline-start: 50%;
}
div#sitesAndAreasTreelist {
  // height: 510px;
  overflow: hidden;
  .selectActions {
    width: 133px !important;
    .dx-dropdownbutton-action.dx-buttongroup-item-has-width:lang(ar),
    .dx-buttongroup-wrapper:lang(ar).dx-widget:lang(ar).dx-collection:lang(ar),
    .dx-button-content:lang(ar) {
      width: 150px !important;
    }
    .dx-button-content:lang(ar) {
      justify-content: space-evenly !important;
    }
    .dx-icon-right:lang(ar)::before {
      width: 0 !important;
    }
    .dx-button-content {
      width: 133px !important;
    }
    .dx-button-text {
      width: 90.08px;
      margin-inline-end: 6px;
    }
    .dx-widget.dx-dropdownbutton.dx-dropdownbutton-has-arrow
      .dx-button-content {
      justify-content: space-between !important;
      width: -webkit-fill-available;
    }
    .dx-icon-right::before {
      justify-content: center !important;
    }
  }
  .dx-treelist-headers .dx-treelist-table .dx-row > td {
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 17px !important;

    color: #787878 !important;
  }
  td {
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 19px !important;

    color: #4a4a4a !important;
  }

  .dx-treelist-header-panel {
    padding-inline-start: 0 !important;
    padding-inline-end: 0 !important;
  }
  .dx-treelist-filter-row {
    background-color: #ffff;
    height: 42px !important;
    padding: 0px !important;
    margin: 0px !important;
  }
}
div#deleteSite {
  div#deleteSite___BV_modal_content_ {
    width: 597px;
    position: absolute;
    float: inline-start;
    top: 50%;
    transform: translate(-50%, 30%);
    div#deleteSite___BV_modal_body_ {
      padding: 0px !important;

      .delete-user-type-wrapper {
        padding-top: 41px !important;
        padding-inline-end: 0px !important;
        padding-bottom: 0px !important;
        padding-inline-start: 46px !important;
        .bold-txt {
          font-weight: 700;
          font-size: 20px;
          line-height: 38px;

          text-align: center;

          color: #787878;
        }
        h4.allareakiosk-header {
          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          color: #000000;
          margin-top: 0px;
          margin-inline-end: auto;
          margin-bottom: 38px;
          margin-inline-start: 0px;
          text-align: center;
        }
        p.custom-Question {
          font-weight: 400;
          font-size: 20px;
          line-height: 38px;
          margin-inline-start: 13px;
          margin-inline-end: 60px;
          margin-bottom: 17px;

          text-align: center;

          color: #787878;
        }
        p.confirmation-msg {
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          margin-inline-start: 13px;
          margin-inline-end: 60px;
          margin-bottom: 34px;
          text-align: center;
          letter-spacing: 0.25px;

          /* #939393 */

          color: #939393;
        }

        .actionsline-inside {
          background: #707070;
          height: 1px;
          opacity: 0.15;
          // margin-top: 43px;
          margin-bottom: 20px;
          margin-inline-end: 36px !important;
        }
        .actions-btns {
          margin-inline-end: 36px;
          // background: red;
          margin-bottom: 21px;
          display: flex;
          align-items: center;
          justify-content: center;
          .submit-btn {
            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
            color: #ffffff !important;
            margin-inline-end: 15px !important;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .cancel-reject {
            margin-inline-start: 15px;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;

            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
          }
        }
      }
    }
  }
}
:dir(ltr) div#deleteArea div#deleteArea___BV_modal_content_ {
  inset-inline-start: 50%;
}
:dir(rtl) div#deleteArea div#deleteArea___BV_modal_content_ {
  inset-inline-start: -50%;
}
div#deleteArea {
  div#deleteArea___BV_modal_content_ {
    width: 597px;
    position: absolute;
    float: inline-start;
    top: 50%;
    transform: translate(-50%, 30%);
    div#deleteArea___BV_modal_body_ {
      padding: 0px !important;

      .delete-user-type-wrapper {
        padding-top: 41px !important;
        padding-inline-end: 0px !important;
        padding-bottom: 0px !important;
        padding-inline-start: 46px !important;
        .bold-txt {
          font-weight: 700;
          font-size: 20px;
          line-height: 38px;

          text-align: center;

          color: #787878;
        }
        h4.allareakiosk-header {
          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          color: #000000;
          margin-top: 0px;
          margin-inline-end: auto;
          margin-bottom: 38px;
          margin-inline-start: 0px;
          text-align: center;
        }
        p.custom-Question {
          font-weight: 400;
          font-size: 20px;
          line-height: 38px;
          margin-inline-start: 13px;
          margin-inline-end: 60px;
          margin-bottom: 17px;

          text-align: center;

          color: #787878;
        }
        p.confirmation-msg {
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          margin-inline-start: 13px;
          margin-inline-end: 60px;
          margin-bottom: 34px;
          text-align: center;
          letter-spacing: 0.25px;

          /* #939393 */

          color: #939393;
        }

        .actionsline-inside {
          background: #707070;
          height: 1px;
          opacity: 0.15;
          // margin-top: 43px;
          margin-bottom: 20px;
          margin-inline-end: 36px !important;
        }
        .actions-btns {
          margin-inline-end: 36px;
          // background: red;
          margin-bottom: 21px;
          display: flex;
          align-items: center;
          justify-content: center;
          .submit-btn {
            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
            color: #ffffff !important;
            margin-inline-end: 15px !important;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .cancel-reject {
            margin-inline-start: 15px;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;

            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
          }
        }
      }
    }
  }
}
div#deleteRemoteArea {
  div#deleteRemoteArea___BV_modal_content_ {
    width: 597px;
    position: absolute;
    float: inline-start;
    inset-inline-start: 50%;
    top: 50%;
    transform: translate(-50%, 30%);
    div#deleteRemoteArea___BV_modal_body_ {
      padding: 0px !important;

      .delete-user-type-wrapper {
        padding-top: 41px !important;
        padding-inline-end: 0px !important;
        padding-bottom: 0px !important;
        padding-inline-start: 46px !important;
        .bold-txt {
          font-weight: 700;
          font-size: 20px;
          line-height: 38px;

          text-align: center;

          color: #787878;
        }
        h4.allareakiosk-header {
          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          color: #000000;
          margin-top: 0px;
          margin-inline-end: auto;
          margin-bottom: 38px;
          margin-inline-start: 0px;
          text-align: center;
        }
        p.custom-Question {
          font-weight: 400;
          font-size: 20px;
          line-height: 38px;
          margin-inline-start: 13px;
          margin-inline-end: 60px;
          margin-bottom: 17px;

          text-align: center;

          color: #787878;
        }
        p.confirmation-msg {
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          margin-inline-start: 13px;
          margin-inline-end: 60px;
          margin-bottom: 34px;
          text-align: center;
          letter-spacing: 0.25px;

          /* #939393 */

          color: #939393;
        }

        .actionsline-inside {
          background: #707070;
          height: 1px;
          opacity: 0.15;
          // margin-top: 43px;
          margin-bottom: 20px;
          margin-inline-end: 36px !important;
        }
        .actions-btns {
          margin-inline-end: 36px;
          // background: red;
          margin-bottom: 21px;
          display: flex;
          align-items: center;
          justify-content: center;
          .submit-btn {
            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
            color: #ffffff !important;
            margin-inline-end: 15px !important;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .cancel-reject {
            margin-inline-start: 15px;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;

            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
          }
        }
      }
    }
  }
}
div#deleteKiosk {
  div#deleteKiosk___BV_modal_content_ {
    width: 597px;
    position: absolute;
    float: inline-start;
    inset-inline-start: 50%;
    top: 50%;
    transform: translate(-50%, 30%);
    div#deleteKiosk___BV_modal_body_ {
      padding: 0px !important;

      .delete-user-type-wrapper {
        padding-top: 41px !important;
        padding-inline-end: 0px !important;
        padding-bottom: 0px !important;
        padding-inline-start: 46px !important;
        .bold-txt {
          font-weight: 700;
          font-size: 20px;
          line-height: 38px;

          text-align: center;

          color: #787878;
        }
        h4.allareakiosk-header {
          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          color: #000000;
          margin-top: 0px;
          margin-inline-end: auto;
          margin-bottom: 38px;
          margin-inline-start: 0px;
          text-align: center;
        }
        p.custom-Question {
          font-weight: 400;
          font-size: 20px;
          line-height: 38px;
          margin-inline-start: 13px;
          margin-inline-end: 60px;
          margin-bottom: 17px;

          text-align: center;

          color: #787878;
        }
        p.confirmation-msg {
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          margin-inline-start: 13px;
          margin-inline-end: 60px;
          margin-bottom: 34px;
          text-align: center;
          letter-spacing: 0.25px;

          /* #939393 */

          color: #939393;
        }

        .actionsline-inside {
          background: #707070;
          height: 1px;
          opacity: 0.15;
          // margin-top: 43px;
          margin-bottom: 20px;
          margin-inline-end: 36px !important;
        }
        .actions-btns {
          margin-inline-end: 36px;
          // background: red;
          margin-bottom: 21px;
          display: flex;
          align-items: center;
          justify-content: center;
          .submit-btn {
            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
            color: #ffffff !important;
            margin-inline-end: 15px !important;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .cancel-reject {
            margin-inline-start: 15px;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;

            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
          }
        }
      }
    }
  }
}
.sites-white-bg-sec {
  background-color: white;
  padding-inline-start: 0px;
  border-radius: 8px !important;
  .toolbar-action-button {
    border-radius: 4px;
    letter-spacing: normal;
    background: #2680eb;
    overflow: hidden;

    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #fff;
    height: 27px;
    width: 95px;
    background-color: #2680eb !important;
    border-color: #2680eb !important;
    margin-inline-start: 16px;
    cursor: pointer !important;
    .toolbar-action-text {
      cursor: pointer !important;
    }
  }
  .expand-all {
    width: 88px;
  }
  .dx-toolbar-item-content:disabled {
    opacity: 0.6 !important;
    .custom-text,
    .toolbar-action-text {
      cursor: not-allowed !important;
    }
    cursor: not-allowed !important;
  }
}
.custom-red-delete {
  .p-menuitem-text {
    color: #f46a6a !important;
    font-size: 17.5px !important;
    text-align: center;
    line-height: 19px !important;
    cursor: pointer !important;
  }
}

// .printer-cell{
//   margin-bottom:-17px;
// }

.white-space-nowrap {
  white-space: nowrap !important;
}
</style>
